module.exports = __webpack_public_path__ + "static/media/correcto_castellano.dd9e9db6.png";